import { dew as _fromDew } from "../array/from";
import { dew as _assignDew } from "./assign";
import { dew as _validValueDew } from "./valid-value";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;

  var aFrom = _fromDew(),
      assign = _assignDew(),
      value = _validValueDew();

  exports = function (obj
  /*, propertyNames, options*/
  ) {
    var copy = Object(value(obj)),
        propertyNames = arguments[1],
        options = Object(arguments[2]);
    if (copy !== obj && !propertyNames) return copy;
    var result = {};

    if (propertyNames) {
      aFrom(propertyNames, function (propertyName) {
        if (options.ensure || propertyName in obj) result[propertyName] = obj[propertyName];
      });
    } else {
      assign(result, obj);
    }

    return result;
  };

  return exports;
}